import React, { useState } from "react";
import styles from "./SuperAdminOrgConfigsPage.module.scss";
import { BaseModal, ModalHeader } from "@whatslly/ui-components/modals";
import { IModalInstance } from "@whatslly/ui-components/modals/ModalProvider";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { OrgSelectionSelectComponent } from "../../components/Filters/components/OrgSelect";

type ImportConfigModalProps = IModalInstance<{ value: string; label: string }>;

export const ImportConfigModal: React.FC<ImportConfigModalProps> = observer(({ closeModal }) => {
  const [selectedOrg, setSelectedOrg] = useState<{ value: string; label: string }>();
  const { t } = useTranslation();

  return (
    <BaseModal
      header={<ModalHeader closeModal={closeModal}>{t("super_admin_org_configs.import_configuration")}</ModalHeader>}
      closeModal={closeModal}
      className={styles.importConfigModal}
    >
      <div className={styles.modalSelectContainer}>
        <OrgSelectionSelectComponent customHandling={{ value: selectedOrg, onChange: (selectedOption) => setSelectedOrg(selectedOption) }} />
      </div>
      <ModalButtons isSubmitDisabled={!selectedOrg} onSubmit={() => closeModal(selectedOrg)} onCancel={() => closeModal()} />
    </BaseModal>
  );
});
